/**
 * @license Copyright 2019 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with the License. You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.
 */

import {useRef, useEffect} from 'preact/hooks';

/**
 * @template T
 * @param {T} value
 * @return {T|null|undefined}
 */
export function usePreviousValue(value) {
  /** @type {import('preact').Ref<T|undefined>} */
  const ref = useRef(undefined);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  // This is returned before our useEffect callback runs to update the value.
  return ref.current;
}
